import React, { useEffect } from "react";
import Navbar from "../sections/Navbar";
import MessageSection from "../sections/MessageSection";
import ContactSection from "../sections/ContactSection";
import styles from "./ContactPage.module.css";

const ContactPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={styles.mainDesign}>
      <Navbar />
      
      <div className={styles.heroSection} style={{ backgroundImage: "url('/media/contact_bg.png')" }}>
        <div className={styles.heroContent}>
          <h1 className={styles.heroTitle}>Let's Build Something Amazing.</h1>
          <p className={styles.heroSubtitle}>
            Whether you have a question, a project in mind, or just want to say hello, we'd love to hear from you.
          </p>
        </div>
      </div>

      <div className={styles.contactContainer}>
        <div className={styles.contactGrid}>
          <div className={styles.contactInfo}>
            <h2>Reach Out To Us</h2>
            <p>Our team is ready to assist you with your design journey.</p>
            
            <div className={styles.infoBlock}>
              <h3>Email</h3>
              <a href="mailto:business@shakadesignlab.com">business@shakadesignlab.com</a>
            </div>

            <div className={styles.infoBlock}>
              <h3>Phone</h3>
              <a href="tel:+918100139058">+91 8100 139058</a>
            </div>

            <div className={styles.infoBlock}>
              <h3>Address</h3>
              <p>ESBT5A606 , Tower 5A , Ecospace Business Towers<br/>Plot II/F/3 , Newtown Action Area 2A<br/>Kolkata 700160</p>
            </div>
          </div>

          <div className={styles.formContainer}>
            <MessageSection
              hideTitle={true}
              className={styles.customMessageSection}
              formSource="Contact Page Contact Form"
            />
          </div>
        </div>
      </div>

      <ContactSection />
      
      <div className={styles.footerContainer}>
        <div className={styles.footer}>
          <div className={styles.shakaDesignsLlp}>
            ©2024 | ShaKa Designs LLP. All rights reserved.
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
